import React, { useEffect, useRef, useState } from "react";
import SiteHead from "../component/head/SiteHead";
import Link from "next/link";
import SiteAppNoSSR from "../component/app/SiteAppNoSSR";
import { useWebsiteRoutePathname } from "../component/hooks";
import { generateCreateAccountPath } from "../pixelmixer-webapp/src/service/AmplifyLoginService";
import { logDebug } from "../pixelmixer-webapp/src/service/ServiceUtil";
import Footer from "../component/footer/Footer";
import PageBreadcrumbTitle from "../component/nav/PageBreadcrumbTitle";

const LoginPage = ({ nonce }) => {
  const pathname = useWebsiteRoutePathname();

  return (
    <>
      <SiteHead showNavBar={false} enableFloatingNavBar={false} nonce={nonce} />
      <div className="background-gradient">
        <div className="background-gradient-overlay"></div>

        {/* <!--===== WELCOME STARTS =======--> */}
        <div className="form-page-container login">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 m-auto">
                <PageBreadcrumbTitle pageName="Login" />
                <div className="space50"></div>
                <div className="form-panel heading6">
                  <h2 className="title" id="login-title">
                    <ion-icon name="log-in-outline" class="icons"></ion-icon>
                    Login
                  </h2>
                  <div className="space16"></div>
                  <p className="text-center">Welcome back!</p>
                  <div className="space50"></div>
                  <SiteAppNoSSR />
                  <div className="space32"></div>
                  <div className="col-md-12 text-center">
                    <p className="create-account">
                      Don't have an account?&nbsp;
                      <Link
                        href={generateCreateAccountPath(pathname)}
                        className="purple-color"
                      >
                        Sign up
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--===== WELCOME ENDS =======--> */}
      </div>
      <Footer includeSignup={false} />
    </>
  );
};

export default LoginPage;
